import { useEffect, useState } from "react";
import { Fragment } from "react";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { MinusIcon, PlusIcon, Squares2X2Icon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { fetchAllProductsByFiltersAsync, selectAllProducts, fetchAllProductsCategoryAsync } from "./ProductList_Slice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MAX_ITEM_LIMIT } from "../../app/constants";
import { userWishlist, addItemInUserWishlistAsync, removeItemFromUserWishlistAsync } from "../User/userSlice";
import { loggedInUser } from "../Auth/Auth_Slice";
import toast from "react-hot-toast"

const sortOptions = [
  { name: "Relevance", sort: null, order: null }, // Default option
  { name: "Price: Low to High", sort: "price", order: "asc" },
  { name: "Price: High to Low", sort: "price", order: "desc" },
  //{ name: "Best Rating", sort: "rating", order: "desc" },
];

const formatNumber = (number) => {
  if (number) {
    let x = number;
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
      lastThree = ',' + lastThree;
    let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
}

export default function ProductList_Compo() {

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  //STATE 
  const products = useSelector(selectAllProducts);
  const wishlist = useSelector(userWishlist);
  const user = useSelector(loggedInUser)
  const parentCategories = useSelector(state => state.product.parentCateogories);
  const subCategoy = useSelector(state => state.product.subCategories);
  const total_items_count = useSelector((state) => (state.product.totalItems));
  const totalPages = Math.ceil(total_items_count / MAX_ITEM_LIMIT);
  const status = useSelector((state) => state.product.status);

  const [filter, setFilter] = useState({});
  const [sort, setSort] = useState({});
  const [page, setPage] = useState(1);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  const handleSubCategory = (e, subcategory) => {
    const newFilter = { "subCategory": [subcategory] };
    setFilter(newFilter)
  }

  const handleFilter = (e, section, option) => {
    const newFilter = { ...filter };
    if (e.target.checked) {
      if (newFilter[section.id]) {
        newFilter[section.id].push(option.value)
      } else {
        newFilter[section.id] = [option.value];
      }
    } else {
      const index = newFilter[section.id].findIndex(el => el === option.value);

      newFilter[section.id].splice(index, 1);
    }
    setFilter(newFilter)
  }

  const handleSort = (e, option) => {
    if (option.sort && option.order) {
      const newSort = { _sort: option.sort, _order: option.order };
      setSort(newSort);
    } else {
      setSort({});
    }
  }

  const handlePage = (newPage) => {
    setPage(newPage)
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchQuery = params.get("q");//Grab query from url if exists

    const pagination = { _page: page, _limit: MAX_ITEM_LIMIT };
    dispatch(fetchAllProductsByFiltersAsync({ filter, sort, pagination, search: searchQuery }));
  }, [dispatch, filter, sort, page, subCategoy, location.search])

  useEffect(() => {
    setPage(1)
  }, [total_items_count, sort, subCategoy])

  useEffect(() => {
    dispatch(fetchAllProductsCategoryAsync());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleWishlistStatus = (productId) => {
    if (user != null && user?.isAuthenticated) {
      const wishlistProduct = wishlist.find(item => item.productId === productId);
      return !!wishlistProduct;
    }
    return false
  }

  const handleSaveToWishlist = (productId) => {
    if (user && user?.isAuthenticated && products) {
      dispatch(addItemInUserWishlistAsync(productId)).then((response) => {
        if (response.payload.status === 'success') {
          toast.success("Added to your Wishlist.", { id: "success" })
        } else {
          toast.error(response.payload.message, { id: "error" })
        }
      });
    } else {
      toast.error("Login to add in wishlist.", { id: "error" })
    }
  }

  const handleRemoveFromWishlist = (productId) => {
    if (user && user?.isAuthenticated && products) {
      dispatch(removeItemFromUserWishlistAsync(productId)).then((response) => {
        if (response.payload.status === 'success') {
          toast.success("Product removed from Wishlist.", { id: "success" })
        } else {
          toast.error(response.payload.message, { id: "error" })
        }
      });
    }
  }


  const subCategories = [...subCategoy];

  const filters = [
    {
      id: "category",
      name: "Category",
      options: [...parentCategories],
    },
    {
      id: "brand",
      name: "Brand",
      options: [

        { value: "oppo", label: "Oppo", checked: false },
        { value: "samsung", label: "Samsung", checked: false },
        { value: "realme", label: "Realme", checked: false },
        { value: "boat", label: "Boat", checked: false },
        { value: "oneplus", label: "Oneplus", checked: false },
        { value: "vivo", label: "Vivo", checked: false },
      ],
    },
  ];

  const start = (page - 1) * MAX_ITEM_LIMIT + 1;
  const end = page * MAX_ITEM_LIMIT > total_items_count ? total_items_count : page * MAX_ITEM_LIMIT;


  return (
    <div className="mainBodyContainerColor">
      <div>
        {/* Mobile filter dialog */}
        <MobileFilter filter={filter} handleFilter={handleFilter} filters={filters} mobileFiltersOpen={mobileFiltersOpen} subCategories={subCategories} setMobileFiltersOpen={setMobileFiltersOpen} handleSubCategory={handleSubCategory} totalItems={total_items_count} />
        {/* End Of Mobile filter dialog */}
        <main className="mx-auto w-100 px-4">
          {/* <div className="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-10">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900">
              New Arrivals
            </h1>
            <div className="flex items-center">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                    Sort
                    <ChevronDownIcon
                      className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95" >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="py-1">
                      {sortOptions.map((option) => (
                        <Menu.Item key={option.name}>
                          {({ active }) => (
                            <p onClick={(e) => handleSort(e, option)} className={classNames(option.current ? "font-medium text-gray-900 " : "text-gray-500", active ? "bg-gray-100" : "", "block px-4 py-2 text-sm cursor-pointer")} >
                              {option.name}
                            </p>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
              <button type="button" className="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7" >
                <span className="sr-only">View grid</span>
                <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
              </button>
              <button type="button" className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden" onClick={() => setMobileFiltersOpen(true)} >
                <span className="sr-only">Filters</span>
                <FunnelIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div> */}

          <section aria-labelledby="products-heading" className="py-4">
            <h2 id="products-heading" className="sr-only"> Products </h2>
            <div className="grid grid-cols-1 gap-x-4 gap-y-10 lg:grid-cols-5">
              {/* Desktop Filters */}
              <DesktopFilter filter={filter} handleFilter={handleFilter} filters={filters} subCategories={subCategories} handleSubCategory={handleSubCategory} totalItems={total_items_count} />
              {/*End Of Desktop Filters */}
              {/* Product grid */}
              {/* Product grid area */}
              <div className="lg:col-span-4 min-h-[60vh]">
                <div className="bg-white py-5 h-full rounded-md">

                  {/* 1. LOADING STATE */}
                  {status === 'loading' ? (
                    <div className="flex flex-col items-center justify-center py-20">
                      <div className="relative w-16 h-16">
                        <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-100 rounded-full"></div>
                        <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
                      </div>
                      <p className="mt-4 text-gray-500 font-medium animate-pulse">Fetching best products for you...</p>
                    </div>
                  ) :

                    /* 2. EMPTY STATE (NO RESULTS) */
                    total_items_count === 0 ? (
                      <div className="flex flex-col items-center justify-center py-20 text-center px-4">
                        <div className="bg-gray-50 p-6 rounded-full mb-4">
                          <Squares2X2Icon className="h-12 w-12 text-gray-300" />
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">No results found</h3>
                        <p className="mt-2 text-sm text-gray-500 max-w-xs">
                          We couldn't find anything matching your search or filters. Try adjusting them to find what you're looking for.
                        </p>
                        <button
                          onClick={() => {
                            setFilter({}); // Filter state reset
                            setSort({});   // Sort state reset
                            setPage(1);    // Page 1 default set
                            navigate('/'); // Redirect
                          }}
                          className="mt-6 px-6 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 transition-all shadow-sm"
                        >
                          Clear All Filters
                        </button>
                      </div>
                    ) : (

                      <>
                        {/* Sort Bar */}
                        <div className="space-y-1 mb-6 sm:px-6 lg:px-8 w-100 border-b-[1px] border-gray-100">
                          <h2 className="font-bold text-gray-900 tracking-tight text-lg">
                            {start === end ? (
                              <>Showing result {end} of {total_items_count}</>
                            ) : (
                              <>Showing {start} – {end} of {total_items_count} results</>
                            )}
                          </h2>

                          <div className="flex items-center space-x-2 sm:space-x-6 pt-2 text-gray-600 font-medium pb-2 border-b-[1px] border-gray-100">
                            <p className="text-[11px] sm:text-xs text-gray-400 min-w-fit uppercase tracking-wider">Sort By:</p>

                            <div className="flex items-center space-x-3 sm:space-x-6">
                              {sortOptions.map((option) => (
                                <p
                                  key={option.name}
                                  onClick={(e) => handleSort(e, option)}
                                  className={`text-[12px] sm:text-sm cursor-pointer whitespace-nowrap px-0.5 border-b-2 transition-all duration-200 font-medium
                                        ${(sort._sort === option.sort && sort._order === option.order) || (!sort._sort && !option.sort)
                                      ? "text-indigo-600 border-indigo-600"
                                      : "text-gray-500 border-transparent hover:text-gray-800 hover:border-gray-200"
                                    }`
                                  }
                                >
                                  {option.name}
                                </p>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Product Grid */}
                        <div className="mx-auto max-w-2xl px-2 py-4 sm:px-6 lg:max-w-7xl lg:px-8">
                          <div className="grid grid-cols-2 gap-x-2 gap-y-4 sm:gap-x-4 sm:gap-y-8 lg:grid-cols-4 xl:gap-x-6">
                            {products.map((product) => (
                              <div
                                key={product.id}
                                className="group relative bg-white shadow-sm border-[1px] border-gray-100 p-1.5 sm:p-3 rounded-lg hover:shadow-md transition-all duration-300 text-gray-700 flex flex-col"
                              >
                                {/* Wishlist Button - Scaled for mobile */}
                                <div
                                  className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full shadow-sm cursor-pointer z-10 hover:scale-110 transition-transform"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleWishlistStatus(product.id) ? handleRemoveFromWishlist(product.id) : handleSaveToWishlist(product.id);
                                  }}
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={`w-3.5 h-3.5 ${handleWishlistStatus(product.id) ? "text-red-500" : "text-gray-300"}`}>
                                    <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
                                  </svg>
                                </div>

                                <div className="aspect-square w-full overflow-hidden rounded-md bg-white">
                                  <img
                                    src={product.images[0]}
                                    alt={product.name}
                                    className="w-full h-full p-2 sm:p-4 object-contain group-hover:scale-105 transition-transform duration-500"
                                  />
                                </div>

                                {/* Details Section */}
                                <div className="mt-2 sm:mt-4 space-y-1 px-1">
                                  <h3 className="text-[11px] sm:text-sm text-gray-700 font-semibold line-clamp-2 min-h-[28px] sm:min-h-[40px] leading-tight">
                                    <Link to={`/${product.href}/${product.id}`}>
                                      <span aria-hidden="true" className="absolute inset-0" />
                                      {product.name}
                                    </Link>
                                  </h3>

                                  {/* Pricing */}
                                  <div className="flex items-center gap-1.5 pt-0.5">
                                    <span className="text-sm sm:text-base font-extrabold text-gray-900">₹{formatNumber(product.price)}</span>
                                    <span className="hidden sm:inline text-[10px] text-gray-400 line-through">₹{formatNumber(product.originalPrice)}</span>
                                  </div>

                                  {/* Discount Badge */}
                                  <div className="flex items-center gap-2">
                                    <span className='text-[9px] sm:text-[10px] font-bold text-green-600 bg-green-50 px-1.5 py-0.5 rounded'>
                                      {100 - (Math.round((product.price / product.originalPrice) * 100))}% OFF
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </section>
          {/* Pagination component*/}
          <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-8 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
              {/* Mobile Navigation */}
              <div onClick={() => handlePage(page > 1 ? page - 1 : page)} className={`relative ${page > 1 ? "cursor-pointer text-gray-900" : "pointer-events-none text-gray-400"} inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50`} >
                Previous
              </div>
              <div onClick={() => handlePage(page < totalPages ? page + 1 : page)} className={`relative ${page < totalPages ? "cursor-pointer text-gray-900" : "pointer-events-none text-gray-400"} ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50`} >
                Next
              </div>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  {total_items_count === 0 ? (
                    "No results found"
                  ) : start === end ? (
                    <>
                      Showing result <span className="font-medium">{end}</span> of{' '}
                      <span className="font-medium">{total_items_count}</span>
                    </>
                  ) : (
                    <>
                      Showing <span className="font-medium">{start}</span> to{' '}
                      <span className="font-medium">{end}</span> of{' '}
                      <span className="font-medium">{total_items_count}</span> results
                    </>
                  )}
                </p>
              </div>
              <div>
                <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                  <div onClick={() => handlePage(page > 1 ? page - 1 : page)} className={`relative ${page > 1 ? "cursor-pointer text-gray-900" : "pointer-events-none text-gray-400"} inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0`}>
                    <ChevronLeftIcon className="h-5 w-5 " aria-hidden="true" />
                    <span className="font-medium text-sm">Previous</span>
                  </div>
                  {/* Pagination Main Nav */}
                  {Array.from({ length: totalPages }).map((el, index) => (
                    <Link href="#" key={index} onClick={() => handlePage(index + 1)} className={`${page === index + 1 ? "relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" : " relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"}`} >
                      {index + 1}
                    </Link>
                  ))}
                  <Link href="#" onClick={() => handlePage(page < totalPages ? page + 1 : page)} className={`relative ${page < totalPages ? "cursor-pointer text-gray-900" : "pointer-events-none text-gray-400"} inline-flex  items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0`}>
                    <span className="font-medium text-sm">Next</span>
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </Link>
                </nav>
              </div>
            </div>
          </div>
          {/* pagination end here */}
        </main>
      </div>
    </div>
  );
}



function MobileFilter({ filter, handleFilter, mobileFiltersOpen, setMobileFiltersOpen, filters, subCategories, handleSubCategory, totalItems }) {
  return (
    <Transition.Root show={mobileFiltersOpen} as={Fragment}>
      <Dialog as="div" className="relative z-40 lg:hidden" onClose={setMobileFiltersOpen}>
        <Transition.Child as={Fragment} enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0" >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>
        <div className="fixed inset-0 z-40 flex">
          <Transition.Child as={Fragment} enter="transition ease-in-out duration-300 transform" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="translate-x-full" >
            <Dialog.Panel className="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
              <div className="flex items-center justify-between px-4">
                <h2 className="text-lg font-medium text-gray-900">
                  Filters
                </h2>
                <button type="button" className="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400" onClick={() => setMobileFiltersOpen(false)} >
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>

              <form className={`mt-4 border-t border-gray-200 transition-all duration-300 ${totalItems === 0 ? 'pointer-events-none opacity-40 grayscale select-none' : ''}`}>
                <h3 className="sr-only">Categories</h3>
                <ul className="px-2 py-3 font-medium text-gray-900">
                  {subCategories.map((category) => (
                    <li key={category.value}>
                      <Link href={category.href} className="block px-2 py-3">
                        {category.label}
                      </Link>
                    </li>
                  ))}
                </ul>
                {filters.map((section) => (
                  <Disclosure as="div" key={section.id} className="border-t border-gray-200 px-4 py-6" >
                    {({ open }) => (
                      <>
                        <h3 className="-mx-2 -my-3 flow-root">
                          <Disclosure.Button className="flex w-full items-center justify-between bg-white px-2 py-3 text-gray-400 hover:text-gray-500">
                            <span className="font-medium text-gray-900">
                              {section.name}
                            </span>
                            <span className="ml-6 flex items-center">
                              {open ? (<MinusIcon className="h-5 w-5" aria-hidden="true" />
                              ) : (
                                <PlusIcon className="h-5 w-5" aria-hidden="true" />
                              )}
                            </span>
                          </Disclosure.Button>
                        </h3>
                        <Disclosure.Panel className="pt-6">
                          <div className="space-y-6">
                            {section.options.map((option, optionIdx) => (
                              <div key={option.value} className="flex items-center" >
                                <input id={`filter-mobile-${section.id}-${optionIdx}`} name={`${section.id}[]`} defaultValue={option.value} type="checkbox" onChange={e => handleFilter(e, section, option)} defaultChecked={filter.brand ? filter.brand.includes(option.value) ? true : false : null} className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                                <label htmlFor={`filter-mobile-${section.id}-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-500" >
                                  {option.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ))}
              </form>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}


function DesktopFilter({ filter, handleFilter, filters, subCategories, handleSubCategory, totalItems }) {
  return (
    <form className={`hidden lg:block bg-white md:px-4 lg:px-6 mycustomshadow1 py-4 transition-all duration-300 ${totalItems === 0 ? 'pointer-events-none opacity-40 grayscale select-none' : ''}`}>
      <h3 className="sr-only">Categories</h3>
      <h3 className="text-lg font-bold tracking-tight text-gray-900 border-b-[1px] border-gray-200 pb-2 mb-4">Filters</h3>
      {/* <ul className="space-y-2 border-b capitalize border-gray-200 pb-6 text-sm font-medium text-gray-900 overflow-auto max-h-64">
        {subCategories.map((category) => (
          <li key={category.value} className="captialize">
            <Link onClick={(e) => handleSubCategory(e, category.value)}>{category.label}</Link>
          </li>
        ))}
      </ul> */}
      {filters.map((section) => (
        <Disclosure as="div" defaultOpen={true} key={section.id} className="border-b border-gray-200 py-6 capitalize">
          {({ open }) => (
            <>
              <h3 className="-my-3 flow-root">
                <Disclosure.Button className="flex w-full items-center justify-between bg-white py-3 text-sm text-gray-400 hover:text-gray-500">
                  <span className="font-medium text-gray-900 ">
                    {section.name}
                  </span>
                  <span className="ml-6 flex items-center">
                    {open ? (
                      <MinusIcon className="h-5 w-5" aria-hidden="true" />)
                      : (<PlusIcon className="h-5 w-5" aria-hidden="true" />
                      )}
                  </span>
                </Disclosure.Button>
              </h3>
              <Disclosure.Panel className="pt-6">
                <div className="space-y-4">
                  {section.options.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center" >
                      <input id={`filter-${section.id}-${optionIdx}`} name={`${section.id}[]`} defaultValue={option.value} type="checkbox" defaultChecked={filter.brand ? filter.brand.includes(option.value) ? true : false : null} onChange={e => handleFilter(e, section, option)} className="h-4 w-4 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" />
                      <label htmlFor={`filter-${section.id}-${optionIdx}`} className="ml-3 text-sm text-gray-600 cursor-pointer" >
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </form>
  )
}